import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="bg-[#0F2A28] text-white mt-24" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="flex items-center gap-3">
                    <img src="/logo.png" alt="" className="w-10 h-10 rounded-lg object-cover" loading="lazy" />
                    <div className="font-heading text-xl font-bold">
                        أسعار الذهب <span className="brand-shimmer">اليوم</span>
                    </div>
                </div>
                <ul className="flex items-center gap-6 text-sm text-[#D5EAE7]">
                    <li>
                        <Link to="/privacy" data-testid="footer-privacy" className="hover:text-white transition-colors">
                            سياسة الخصوصية
                        </Link>
                    </li>
                    <li>
                        <a
                            href="https://wa.me/message/PBZXECOCDIFXK1"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-contact"
                            className="hover:text-white transition-colors"
                        >
                            تواصل معنا
                        </a>
                    </li>
                </ul>
            </div>
            <div className="border-t border-[#1E5E5A]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-[#A8D5D0]">
                    <p>© {new Date().getFullYear()} أسعار الذهب اليوم. جميع الحقوق محفوظة.</p>
                    <p>الأسعار للأغراض الإرشادية فقط.</p>
                </div>
            </div>
        </footer>
    );
}
